import {Component, OnInit} from '@angular/core';
import {CommonService} from "../../common/common.service";
import {Report} from "../../model/report";
import {User} from "../../model/user";
import {ActivatedRoute, Router} from "@angular/router";
import {NotifierService} from "../notifier/notifier.service";
import {NotificationType} from "../notifier/notification-type.enum";
import {saveAs} from "file-saver";
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {SingleReportService} from "./single-report.service";
import { UserSavedReportsService } from '../user-saved-reports/user-saved-reports.service';
import { UserGuardService } from '../../common/user-guard.service';
import { LogService } from '../../common/log.service';
import {TopMenuService} from "../top-menu/top-menu.service";

@Component({
  selector: 'pbc-single-report',
  templateUrl: './single-report.component.html',
  styleUrls: [ './single-report.component.scss']
})
export class SingleReportComponent implements OnInit {

  reportToShow : Report = {
    id : null,
    title : '',
    description : '',
    fileName : '',
    fileFormat : '',
    demoFileName : '',
    published : false,
    demoDisabled : false,
    publishFrom : '',
    repositoryFileName : '',
    repositoryDemoFileName : '',
    hasRights : false,
    shownToUser : false,
    isFavourite : false,
    sets : [],
    content_type : {
      id : null,
      value : '',
      value_1 : '',
      enabled : false,
      dictId : 99999
    },
    thematics_products : [],
    thematics_institution : [],
    thematics_client_groups : [],
    thematics_area : [],
    thematics_frequency : [],
    excluded_from_groups : [],
    newDemoRepository : false
  };
  private loggedUser : User;
  private loggedUserId : string = '';
  showReportShare : boolean = false;
  private shareReportForm : FormGroup;
  suggestedReports : Array<Report> = [];
  showDownloadDemo : boolean = false;
  iconFileName : string = "";

  showContactForm : boolean = false;
  private contactForm : FormGroup;
  private contactFormMessage : string = '';
  private authData: any;
  constructor(private commonService : CommonService,
              private router : Router,
              private activatedRoute : ActivatedRoute,
              private singleReportService : SingleReportService,
              private notifierService: NotifierService,
              private userSavedReportsService: UserSavedReportsService,
              private topMenuService : TopMenuService,
              private userGuardService: UserGuardService,
              private logService: LogService
              )
  {  }

  ngOnInit() {
    this.authData = JSON.parse(localStorage.getItem('auth_data'));
    let userName = '';

    if (this.authData) {
      this.loggedUser = this.authData.user;
      this.loggedUserId = this.authData.user.id;
      userName = this.authData.user.firstName + ' ' + this.authData.user.lastName;

      this.shareReportForm = new FormGroup({
        'email' : new FormControl('', [Validators.email, Validators.required]),
        'message' : new FormControl('Dzień dobry, być może zainteresuje Cię ten raport. Pozdrawiam, ' + userName),
        'sendCopy' : new FormControl(false)
      });

      this.contactForm = new FormGroup({
        'email' : new FormControl({value:this.loggedUser.email, disabled : true},
          [Validators.email, Validators.required]),
        'firstLastName' : new FormControl(
          {value: this.loggedUser.firstName.concat(' ', this.loggedUser.lastName), disabled : true}, Validators.required),
        'phoneNumber' : new FormControl({value: this.loggedUser.workPhone, disabled  : true}, Validators.required),
        'message' : new FormControl(this.contactFormMessage, Validators.required),
        'sendCopy' : new FormControl(false),
        'agreement' : new FormControl(false, Validators.requiredTrue)
      });
    }

    this.activatedRoute.params.subscribe(queryParams=>{
      const singleReportId = queryParams['reportId'];
      if(!this.authData){
        this.logInitialStateWrongInitialData(this.authData, singleReportId)
        this.notifierService.notify(NotificationType.SIMPLE_NOTIFICATION, "Użytkownik nie jest zalogowany. Przekierowano do strony logowania");
        this.router.navigate(['login/single/', singleReportId]);
        return;
      } else {
        this.getReport(this.loggedUser.id, singleReportId);
      }
    });
    //
    // this.activatedRoute.params.subscribe(queryParams=>{
    //   let reportId = queryParams['reportId'];
    //   this.getReport(this.loggedUser.id, reportId);
    // });

    this.singleReportService.deactivateTopMenuActivePosition.emit(true);

  }

  private logInitialStateWrongInitialData(authData: any, reportId: string) {
    if (authData) {
      if (!authData.user) {
        this.logService.debug('authData.user is null');
      }
    } else {
      this.logService.debug('authData is null');
    }
    if (!reportId) {
      this.logService.warn("reportId should be passed in parameters");
    }
  }

  private shareReportFormReset() {
    this.shareReportForm.controls['email'].reset();
    this.shareReportForm.controls['sendCopy'].reset(false);
  }

  showShareReportFormClick() {
    this.showReportShare = true;
  }

  private closeShareReportFormClick() {
    this.showReportShare = false;
    this.shareReportFormReset();
  }

  private getReport(userId: number, reportId: string) {
    let queryParams = {};
    queryParams['userId'] = userId;
    queryParams['reportId'] = reportId;

    if (isNaN(Number(reportId)))
      this.router.navigate(['404']);
    else
      this.commonService.getUserReports(queryParams).subscribe(
        result => {
          if (result.status !== 1)
            this.notifierService.notify(NotificationType.ERROR_NOTIFICATION,
              "Wystąpił błąd! Nie pobrano danych raportu");
          else {
            if (result.record.length == 1) {
              this.reportToShow = result.record[0];
              let contentTypeLabel = this.reportToShow.content_type.value;
              if (contentTypeLabel == "Daily" || contentTypeLabel == "Weekly" )
                this.iconFileName = "update.png";
              else
                this.iconFileName = contentTypeLabel.toLowerCase()+".png";
            }
            if (result.record.length == 0) {
              this.router.navigate(['404']);
            }
          }

        },
        error => {
          console.log(error);
          this.notifierService.notify(NotificationType.ERROR_NOTIFICATION,
            "Wystąpił błąd! Nie pobrano danych raportu");
        }
      )
  }

  downloadReportClick() {
    this.commonService.downloadReportFile(this.reportToShow.id).subscribe(
      data=> {
        saveAs(data, this.reportToShow.fileName);
      },
      err => {
        console.log(err);
        this.notifierService.notify(NotificationType.ERROR_NOTIFICATION, "Wystąpił błąd! Nie można pobrać wskazanego raportu")
      }
    )
  }

  downloadDemoClick() {
    this.commonService.downloadDemoFile(this.reportToShow.id).subscribe(
      data=>{
        saveAs(data, this.reportToShow.demoFileName);
      },
      err => {
        console.log(err);
        this.notifierService.notify(NotificationType.ERROR_NOTIFICATION, "Wystąpił błąd! Nie można pobrać DEMO wskazanego raportu")
      }
    )
  }
  updateUserReportsCount(){
    let filterParams = {};
    filterParams['id']=this.loggedUserId;
    this.userSavedReportsService.getReportsCount(filterParams).subscribe(
      result => {
        this.topMenuService.userReportsCount.emit(result.record);
      })
  }

  addToFavouritesClick(report : Report) {
    this.commonService.addToFavourites(report.id, this.loggedUser.id).subscribe(
      result=>{
        this.updateUserReportsCount();
        report.isFavourite = true;
        this.notifierService.notify(NotificationType.SUCCESS_NOTIFICATION, "Raport ".concat(report.title, " został dodany do Zapisanych"));
      },
      error => {
        console.log(error);
        this.notifierService.notify(NotificationType.ERROR_NOTIFICATION, "Wystąpił błąd! Raport ".concat(report.title, " nie został dodany do Zapisanych"))
      }
    )
  }

  private shareReportClick() {
    let email = this.shareReportForm.controls['email'].value;
    let message = this.shareReportForm.controls['message'].value;
    this.commonService.shareReport(this.reportToShow.id, this.loggedUser.id, email, message).subscribe(
      result=>{
        if (result.status==1)
          this.notifierService.notify(NotificationType.SUCCESS_NOTIFICATION, "Wysłano link do raportu");
        else
          this.notifierService.notify(NotificationType.ERROR_NOTIFICATION, "Wystąpił błąd: Link nie został wysłany");

        this.shareReportFormReset();
        this.showReportShare = false;
      });
  }

  showDownloadDemoClick() {
    this.showDownloadDemo = true;
  }

  closeDownloadDemoClick() {
    this.showDownloadDemo = false;
  }

  private showContactFormPopup() {
    this.showContactForm = true;
    let contactFormMessage = "Dzień dobry,\n\n".concat("poproszę o ofertę dotyczącą dostępu do raportu \"",
      this.reportToShow.title,"\"\n\n", "Pozdrawiam\n\n", this.loggedUser.firstName, ' ', this.loggedUser.lastName);

    this.contactForm.controls['message'].setValue(contactFormMessage);
    this.commonService.registerClickOnElement('clickOnAskForOffer','singleReport', 'report', this.reportToShow.id).subscribe(
      success => {
        if (success.status != 1)
          console.log(success.message);
      },
      error => {
        console.log(error);
      }
    );
  }

  private closeContactFormPopup() {
    this.showContactForm = false;
    this.contactFormMessage = '';
    this.contactForm.controls['agreement'].setValue(false);
  }

  private sendAccesRequestToReportClick() {
    let email = this.contactForm.controls['email'].value;
    let message = this.contactForm.controls['message'].value;
    let sendCopy = this.contactForm.controls['sendCopy'].value;
    this.commonService.sendAccessRequestUrl(this.loggedUser.id, this.reportToShow.id, message, sendCopy).subscribe(
      result => {
        if (result.status ==1)
          this.notifierService.notify(NotificationType.SUCCESS_NOTIFICATION,
            "Wysłano prośbę o dostęp do raportu");
        else
          this.notifierService.notify(NotificationType.ERROR_NOTIFICATION,
            "Wystąpił błąd! Nie wysłano maila z prośbą o dostęp")
      },
      error => {
        console.log(error);
        this.notifierService.notify(NotificationType.ERROR_NOTIFICATION,
          "Wystąpił błąd! Nie wysłano maila z prośbą o dostęp")
      }
    );
    this.closeContactFormPopup();
  }

  private removeFromFavouritesClick(report : Report) {
    let reportsToRemove = [];
    reportsToRemove.push(report.id);
    this.userSavedReportsService.removeReportsFromSaved(this.loggedUser.id, reportsToRemove).subscribe(
      result => {
        if (result.status != 1)
          this.notifierService.notify(NotificationType.ERROR_NOTIFICATION,
            "Wystąpił błąd! Nie usunięto raportu z zapisanych");
        else {
          this.notifierService.notify(NotificationType.SUCCESS_NOTIFICATION,
            "Raport ".concat(report.title, "został usunięty z zapisanych"));
          report.isFavourite = false;
          this.updateUserReportsCount();
        }
      },
      error=>{
        console.log(error);
        this.notifierService.notify(NotificationType.ERROR_NOTIFICATION,
          "Wystąpił błąd! Nie usunięto raportu z zapisanych")
      }
    )

  }

}
